import { isValid, parseISO } from 'date-fns'

// Meta's customer-service window: free-form replies are possible for 24h after
// the candidate's last inbound message; after that only template messages send.
// List-level approximation — the thread's window banner stays authoritative.
export const FREE_FORM_WINDOW_HOURS = 24

export type ReplyWindowState = {
	expiresAt: Date
	isOpen: boolean
}

export function replyWindowState(lastInboundAt: string | null, now: Date): ReplyWindowState | null {
	const lastInboundDate = lastInboundAt ? parseISO(lastInboundAt) : null

	if (!lastInboundDate || !isValid(lastInboundDate)) {
		return null
	}

	const expiresAt = new Date(lastInboundDate.getTime() + FREE_FORM_WINDOW_HOURS * 60 * 60 * 1000)

	return { expiresAt, isOpen: expiresAt.getTime() > now.getTime() }
}
